var DialogService = (function () {
    function DialogService($mdDialog, $sce, $rootScope, socket, env, settings, DTS) {
        this.$mdDialog = $mdDialog;
        this.$sce = $sce;
        this.$rootScope = $rootScope;
        this.socket = socket;
        this.env = env;
        this.settings = settings;
        this.DTS = DTS;
        var test = this;
        return;
    }
    DialogService.prototype.openDialog = function ($event, items, DialogController, template, target) {
        //console.log('Received items ', items);
        var parentEl = angular.element(document.body);
        var mod = this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var _this = this;
                    var dResult = this;
                    dResult.comment = 'test';
                    dResult.teamname = items.name;
                    dResult.people = items.members;
                    // you will be returning quest
                    this.clickYes = function ($event) {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    this.clickNo = function ($event) {
                        dResult.confirm = false;
                        $mdDialog.hide(dResult);
                    };
                    this.cancel = function ($event) {
                        $mdDialog.cancel();
                    };
                    this.getAvatar = function (email) {
                        return _this.DTS.getAvatar(email, 115);
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
        return mod;
    };
    DialogService.prototype.openDialog2 = function ($event, items, DialogController, template, target, scope) {
        var parentEl = angular.element(document.body);
        var mod = this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            preserveScope: true,
            scope: scope,
            controller: DialogController,
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
        return mod;
    };
    DialogService.prototype.confirmDelete = function ($event, sample) {
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            template: "\n                <md-dialog>\n                    <p> Are you sure you want to delete this line?</p>\n                    <md-button ng-click=\"vm.confirmDelete()\"> OK </md-button>\n                    <md-button ng-click=\"vm.cancelDelete()\"> Cancel </md-button>\n                </md-dialog>\n                ",
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    var isConfirmed = false;
                    this.confirmDelete = function () {
                        isConfirmed = true;
                        $mdDialog.hide(isConfirmed);
                    };
                    this.cancelDelete = function () {
                        $mdDialog.hide(isConfirmed);
                    };
                }],
            locals: sample,
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    DialogService.prototype.showingErrors = function ($event, sample, template) {
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            locals: sample,
            templateUrl: template,
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    var isOk = false;
                    this.confirmOk = function () {
                        isOk = true;
                        $mdDialog.hide(isOk);
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
    };
    DialogService.prototype.openDialog3 = function ($event, items, DialogController, template, target, scope) {
        var parentEl = angular.element(document.body);
        var try1 = scope.vm;
        //console.log('SCOPE =>', try1);
        var mod = this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            preserveScope: true,
            controller: DialogController,
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: false,
            closeTo: parentEl
        });
        return mod;
    };
    /* dialog for validation tab. Where there are these fields : Old value, new value and
    *comments the following contorller handles the save, cancel events
    */
    DialogService.prototype.updateValidForm = function ($event, items, template, target) {
        var parentEl = angular.element(document.body);
        // console.log(items);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var dResult = this;
                    dResult.comment = '';
                    // you will be returning quest
                    this.clickYes = function ($event) {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    this.clickUploadAdd = function ($event, data) {
                        dResult.confirm = true;
                        dResult.data = data;
                        $mdDialog.hide(dResult);
                    };
                    this.clickUploadReplace = function ($event, data) {
                        dResult.confirm = true;
                        dResult.data = data;
                        $mdDialog.hide(dResult);
                    };
                    this.clickNo = function ($event) {
                        dResult.confirm = false;
                        $mdDialog.hide(dResult);
                    };
                    this.picChange = function ($event) {
                        dResult.divdiv = $event.target.innerHTML;
                    };
                    this.cancel = function ($event) {
                        $mdDialog.cancel();
                    };
                    this.finish = function ($event) {
                        $mdDialog.hide();
                    };
                    this.answer = function () {
                        //pass quest to hide function.
                        $mdDialog.hide(dResult);
                    };
                    this.changeOppty = function () {
                        dResult.confirm = true;
                        //dResult.newOppty = this.newOppty;
                        $mdDialog.hide(dResult);
                    };
                    this.removeBtn = function () {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    // converts the lotus notes link into a clickable link
                    this.convertNotesLink = function () {
                        dResult.processing = true;
                        var tempText = dResult.comment;
                        if (angular.isDefined(dResult.comment) && (tempText.match(/\<NDL\>/g) || []).length) {
                            var noMoreFound = false;
                            var replaceText = '';
                            var ndl = void 0;
                            var hint = void 0;
                            var replica = void 0;
                            var view = void 0;
                            var note = void 0;
                            var rem = void 0;
                            var dbPath = void 0;
                            var docPath = void 0;
                            do {
                                var replaceRem = '';
                                // Look for <NDL> and </NDL> so I can determine, which part is gonna be replaced
                                ndl = { start: -1, end: -1, content: '' };
                                hint = { start: -1, end: -1, content: '' };
                                replica = { start: -1, end: -1, content: '' };
                                view = { start: -1, end: -1, content: '' };
                                note = { start: -1, end: -1, content: '' };
                                dbPath = { start: -1, end: -1, content: '' };
                                docPath = { start: -1, end: -1, content: '' };
                                rem = { start: -1, end: -1, content: '' };
                                ndl.start = tempText.indexOf('<NDL>');
                                ndl.end = tempText.indexOf('</NDL>') + 6;
                                if (ndl.start > -1 && ndl.end > -1 && ndl.end > ndl.start) {
                                    ndl.content = tempText.substring(ndl.start, ndl.end);
                                    var ndlText = angular.copy(ndl.content);
                                    // In hint the server is located and we will convert link only when we get the server
                                    hint.start = ndlText.indexOf('<HINT>CN=');
                                    if (hint.start > -1 && ndlText.length > hint.start + 1) {
                                        hint.end = ndlText.indexOf('/', hint.start + 1);
                                        if (hint.end > -1 && hint.end > hint.start + 9) {
                                            hint.temp = angular.copy(ndlText);
                                            hint.temp = hint.temp.substring(hint.start + 9, hint.end);
                                            hint.content = hint.temp.replace('/', '').trim();
                                        }
                                    }
                                    ;
                                    // Replica contain important information for the link
                                    replica.start = ndlText.indexOf('<REPLICA');
                                    if (replica.start > -1 && ndlText.length > replica.start + 1) {
                                        replica.end = ndlText.indexOf('>', replica.start);
                                        if (replica.end > -1 && replica.end > replica.start + 8) {
                                            replica.temp = angular.copy(ndlText);
                                            replica.temp = replica.temp.substring(replica.start + 8, replica.end);
                                            replica.content = replica.temp.replace(new RegExp('-ON', 'g'), '').replace(new RegExp(':', 'g'), '').trim();
                                        }
                                    }
                                    // View contains important information for the document link
                                    view.start = ndlText.indexOf('<VIEW OF');
                                    if (view.start > -1 && ndlText.length > view.start + 1) {
                                        view.end = ndlText.indexOf('>', view.start + 1);
                                        if (view.end > -1 && view.end > view.start + 8) {
                                            view.temp = angular.copy(ndlText);
                                            view.temp = view.temp.substring(view.start + 8, view.end);
                                            view.content = view.temp.replace(new RegExp('-ON', 'g'), '').replace(new RegExp(':', 'g'), '').trim();
                                        }
                                    }
                                    ;
                                    // note contains important information for the document link
                                    note.start = ndlText.indexOf('<NOTE OF');
                                    if (note.start > -1 && ndlText.length > note.start + 1) {
                                        note.end = ndlText.indexOf('>', note.start);
                                        if (note.end > -1 && note.end > note.start + 8) {
                                            note.temp = angular.copy(ndlText);
                                            note.temp = note.temp.substring(note.start + 8, note.end);
                                            note.content = note.temp.replace(new RegExp('-ON', 'g'), '').replace(new RegExp(':', 'g'), '').trim();
                                        }
                                    }
                                    // Looking for REM to remove the Free text name before the NDL xml object
                                    rem.start = ndlText.indexOf('<REM>');
                                    if (rem.start > -1 && ndlText.length > rem.start + 1) {
                                        rem.end = ndlText.indexOf('</REM>', rem.start + 1);
                                        if (rem.end > -1 && rem.end > rem.start + 5) {
                                            rem.temp = angular.copy(ndlText);
                                            rem.temp = rem.temp.substring(rem.start + 5, rem.end);
                                            dbPath.start = rem.temp.indexOf('Database \'');
                                            docPath.start = rem.temp.indexOf('Document \'');
                                            // If document link, there is a different format of the REM compared to database link.
                                            if (dbPath.start > -1 && docPath.start > -1) {
                                                // DOcument link
                                                if (rem.temp.length > dbPath.start + 10) {
                                                    dbPath.end = rem.temp.indexOf('\'', dbPath.start + 10);
                                                    if (dbPath.end > -1 && dbPath.end > dbPath.start) {
                                                        dbPath.content = rem.temp.substring(dbPath.start + 10, dbPath.end);
                                                    }
                                                }
                                                if (rem.temp.length > docPath.start + 10) {
                                                    docPath.end = rem.temp.indexOf('\'', docPath.start + 10);
                                                    if (docPath.end > -1 && docPath.end > docPath.start) {
                                                        docPath.content = rem.temp.substring(docPath.start + 10, docPath.end);
                                                    }
                                                }
                                                if (dbPath.content.length > 0 && docPath.content.length > 0) {
                                                    replaceRem = dbPath.content + ' - ' + docPath.content;
                                                }
                                            }
                                            else {
                                                // Database link
                                                replaceRem = rem.temp;
                                            }
                                            rem.content = rem.temp.replace('/', '').trim();
                                        }
                                    }
                                    ;
                                    // Replace the copy object with the actual link.
                                    if (hint.content.length > 0 && replica.content.length > 0) {
                                        replaceText = 'Notes://' + hint.content + '/' + replica.content + '/';
                                        if (view.content.length > 0) {
                                            replaceText = replaceText + view.content + '/';
                                        }
                                        if (note.content.length > 0) {
                                            replaceText = replaceText + note.content;
                                        }
                                        tempText = tempText.replace(ndlText, replaceText);
                                        tempText = tempText.replace(replaceRem, '');
                                    }
                                }
                                else {
                                    noMoreFound = true;
                                }
                            } while (!noMoreFound);
                        }
                        dResult.comment = tempText;
                        dResult.processing = false;
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: true,
            escapeToClose: true,
            closeTo: parentEl
        });
    };
    /* dialog for validation tab. Where there are these fields : Old value, new value and
    *comments the following contorller handles the save, cancel events
    */
    DialogService.prototype.YesNoForm = function ($event, items, template, target) {
        var parentEl = angular.element(document.body);
        //console.log(items);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var dResult = this;
                    // you will be returning quest
                    this.clickYes = function ($event) {
                        dResult.confirm = true;
                        $mdDialog.hide(dResult);
                    };
                    this.clickNo = function ($event) {
                        dResult.confirm = false;
                        $mdDialog.hide(dResult);
                    };
                    this.cancel = function ($event) {
                        $mdDialog.cancel();
                    };
                    this.finish = function ($event) {
                        $mdDialog.hide();
                    };
                    this.answer = function () {
                        //pass quest to hide function.
                        $mdDialog.hide(dResult);
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    /* dialog for validation tab. Where there are these fields : Old value, new value and
    *comments the following contorller handles the save, cancel events
    */
    DialogService.prototype.searchResultsForm = function ($event, items, template, target) {
        var parentEl = angular.element(document.body);
        //console.log(items);
        var socketTemp = this.socket;
        var rootScopeTemp = this.$rootScope;
        var envTemp = this.env;
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            bindToController: true,
            locals: items,
            //controller: DialogController,
            controller: ['$mdDialog', function ($mdDialog) {
                    var _this = this;
                    var dResult = this;
                    /*socketTemp.forward('topic.search.export', rootScopeTemp);
                    rootScopeTemp.$on('socket:topic.search.export', (event: ng.IAngularEvent, data: any) => {
                      if (angular.isDefined(data)) {
                          let a: HTMLElement = document.createElement('A');
                          document.body.appendChild(a);
                          a.setAttribute('style', 'display: none;');
                          let url = window.URL.createObjectURL(new Blob([data.payload], {
                              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          }));
                          a.setAttribute('href', url);
                          let d = new Date().toDateString();
                          a.setAttribute('download', `DMT-Search-Report_${d}.xlsx`);
                          a.click();
                      }
                    });*/
                    this.dontSave = function ($event) {
                        $mdDialog.hide();
                    };
                    this.save = function () {
                        //pass quest to hide function.
                        $mdDialog.hide(dResult);
                    };
                    this.excelExport = function () {
                        socketTemp.emit('module', {
                            module: {
                                application: 'dmt',
                                function: 'searchExportExcel',
                                script: '/detail/eligibility/eligibility',
                                data: _this.item.table,
                                token: envTemp.user.token
                            }
                        });
                    };
                    this.removeItem = function (item) {
                        var position = _this.results.table.indexOf(item);
                        if (position > -1) {
                            _this.results.table.splice(position, 1);
                        }
                    };
                    this.addItem = function (item) {
                        if (_this.results.table.indexOf(item) < 0) {
                            _this.results.table.push(item);
                        }
                    };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    //createODSList($event: any, odsDataList: any) {
    // Mimmo - 20180308 - Technical note: below table is fed by odsTables.ts controller.
    DialogService.prototype.createODSList = function (odsDataList, isV4OrLater) {
        var parentEl = angular.element(document.body);
        var seLabel = isV4OrLater ? 'Engagement Id' : 'Solution Id';
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            //targetEvent: $event,
            //RselCustNum => t2Name
            template: "\n                <md-dialog>\n                        <md-toolbar>\n                        <div class=\"md-toolbar-tools\">\n                            <h2>Please Select a Sales Order to Validate</h2>\n                            <span flex></span>\n                            <md-button class=\"md-icon-button\" ng-click=\"vm.cancelSO()\">\n                            <md-icon class=\"white_icon\" md-svg-src=\"/public/images/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n                            </md-button>\n                        </div>\n                        </md-toolbar>\n                    <md-dialog-content style=\"max-width:1000px;max-height:910px; \" >\n                        <table class=\"ibm-data-table ibm-grid ibm-altrows\" style=\"margin: 10px;\">\n                            <thead>\n                                <tr> \n                                     <td class=\"ibm-bgcolor-gray-10\"> Select </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Invoice Number </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> SO Number </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Charge Agreement Num </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Customer Name </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Country </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> SO Date </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Reseller </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Payer </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Part Number </td>\n                                    <td class=\"ibm-bgcolor-gray-10\"> Brand Family </td> \n                                    <td class=\"ibm-bgcolor-gray-10\"> " + seLabel + " </td>      \n                                    <td class=\"ibm-bgcolor-gray-10\"> Extended Price </td> \n                                    <td class=\"ibm-bgcolor-gray-10\"> Customer Designation </td> \n                            </thead>\n                            <tbody style=\"font-size:small\">\n                                <tr ng-repeat=\"oneODS in vm.data\">\n                                    <td> \n                                        <div class = \"select_good checkbox_subcontainer\" ng-style=\"!vm.isDisabledOrder(oneODS) && {'background-color': '#e5e5e5'}\">\n                                            <input type=\"checkbox\" ng-model=\"oneODS.isChecked\"\n                                            ng-disabled=\"!vm.isDisabledOrder(oneODS)\" ng-change=\"vm.checkOrder(oneODS)\" style=\"    width: 20px;\n                                            height: 30px;\">\n                                        </div>\n                                    </td>\n                                    <td> \n                                        <p>{{oneODS.invoiceNo}} </p>\n                                    </td>\n                                    <td> \n                                          <a ng-click=\"$event.preventDefault();vm.confirmSO(oneODS)\">{{oneODS.soNumber}} </a>\n                                    </td>\n                                    <td>\n                                        <p style=\"font-size:small\">{{oneODS.chargeAgreementNum ? oneODS.chargeAgreementNum : '-' }}</p>\n                                    </td>\n                                    <td>\n                                        <p style=\"font-size:small\">{{oneODS.bpName}}</p>\n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.bpCty}}</p>\n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.soDate}}</p>\n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.tier2ResellerNum}}</p> \n                                    </td>\n                                    <td> \n                                        <p style=\"font-size:small\">{{oneODS.tier1DistrNum}}</p>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.pn}}</li>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.brandfamDesc || 'No Description found'}}</li>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.solutionId || 'N/A'}}</li> \n                                    </td>\n                                    <td>\n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.extendPrice | number: 2}}</li>\n                                    </td>\n                                    <td> \n                                        <li style=\"width:max-content\" ng-repeat=\"oneItem in oneODS.itemList\">{{oneItem.customerSegmentCode || 'N/A'}}</li>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <md-button ng-click=\"vm.cancelSO()\" class=\"ibm-btn-pri ibm-btn-small ibm-btn-red-50\"><md-icon class=\"white_icon\" md-svg-icon=\"/public/images/close-circle.svg\"></md-icon> Cancel </md-button>\n                        <md-button ng-disabled=\"!(vm.isOrderSelect)\" ng-click=\"vm.confirmSO()\" class=\"ibm-btn-pri ibm-btn-small ibm-btn-green-50\"> OK </md-button>\n                        </md-dialog-content>\n                </md-dialog>\n                ",
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    var confirmSO = null;
                    var selectedOrders = [];
                    var splitByOrder = [];
                    var soList = [];
                    this.isOrderSelect = false;
                    odsDataList.data.forEach(function (oneData) {
                        if (soList.indexOf(oneData.soNumber) < 0) {
                            splitByOrder.push({ soNumber: oneData.soNumber, data: [oneData] });
                            soList.push(oneData.soNumber);
                        }
                        else {
                            var whereTo = soList.indexOf(oneData.soNumber);
                            splitByOrder[whereTo].data.push(oneData);
                        }
                    });
                    this.sentSelectedOrders = function (orders) {
                        var invoice_numbers = [];
                        orders.forEach(function (el, i) {
                            invoice_numbers.push(el.invoiceNo);
                            if (i !== 0) {
                                orders[0].itemList = orders[0].itemList.concat(el.itemList);
                            }
                        });
                        confirmSO = { data: orders[0], invoice: invoice_numbers };
                        $mdDialog.hide(confirmSO);
                    };
                    this.confirmSO = function (oneODS) {
                        var _this = this;
                        if (oneODS) {
                            splitByOrder.forEach(function (el) {
                                if (el.soNumber === oneODS.soNumber) {
                                    _this.sentSelectedOrders(el.data);
                                }
                            });
                        }
                        else {
                            this.sentSelectedOrders(selectedOrders);
                        }
                    };
                    this.isDisabledOrder = function (odsData) {
                        var isMultipleOrder = false;
                        splitByOrder.forEach(function (el) {
                            if (el.soNumber === odsData.soNumber && el.data.length > 1 && el.data.findIndex(function (el) { return el.isChecked === true; }) > -1) {
                                isMultipleOrder = true;
                            }
                        });
                        if (odsData.isChecked || selectedOrders.length === 0) {
                            return true;
                        }
                        else {
                            return isMultipleOrder ? true : false;
                        }
                    };
                    this.cancelSO = function () {
                        $mdDialog.hide(confirmSO);
                    };
                    this.checkOrder = function (ODS) {
                        if (ODS.isChecked) {
                            selectedOrders.push(ODS);
                            this.isOrderSelect = true;
                        }
                        else {
                            var toDel = selectedOrders.indexOf(ODS);
                            selectedOrders.splice(toDel);
                            this.isOrderSelect = false;
                        }
                    };
                }],
            locals: odsDataList,
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    DialogService.prototype.cancel = function () {
        this.$mdDialog.cancel();
    };
    DialogService.prototype.closeDialog = function () {
        this.$mdDialog.cancel();
    };
    /*
        cancel = function($event: any) {
          this.$mdDialog.cancel();
          alert('Cancel');
        };

        finish = function($event: any) {
          this.$mdDialog.hide();
          alert('Finish');
        };

        answer = (test: any) => {
        //pass quest to hide function.
         this.$mdDialog.hide(test);
         alert('answer');
        };
        */
    DialogService.prototype.showOnlyMessage = function (textLines) {
        // const textLines = {
        //    msgLines: ['Order has been reevaluated']
        // }
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            parent: angular.element(document.body),
            //targetEvent: $event,
            //RselCustNum => t2Name
            template: "\n                <md-dialog>\n                        <p ng-repeat=\"oneLine in vm.msgLines\">{{oneLine}}</p> <!-- singleLineText -->\n                    <md-button ng-click=\"vm.ok()\"> OK </md-button>\n                </md-dialog>\n                ",
            bindToController: true,
            controller: ['$mdDialog', function ($mdDialog) {
                    this.ok = function () {
                        $mdDialog.hide();
                    };
                }],
            locals: textLines,
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: false,
            closeTo: parentEl
        });
    };
    DialogService.$inject = ['$mdDialog', '$sce', '$rootScope', 'socket', 'env', 'settings', 'DTS'];
    return DialogService;
}());
angular
    .module('application')
    .service('Dialog', DialogService);

//# sourceMappingURL=dialog.js.map
